import { useCallback, useSyncExternalStore } from 'react';
/**
 * Subscribe to a single record by id. Re-renders ONLY when that specific
 * record changes — unrelated mutations in the collection do not re-render.
 *
 * Returns `undefined` while the record is absent (not yet loaded / purged).
 */ export function useCollectionItem(collection, id) {
    const subscribe = useCallback((onChange)=>{
        if (id == null) {
            return ()=>undefined;
        }
        return collection.subscribeToId(id, onChange);
    }, [
        collection,
        id
    ]);
    const getSnapshot = useCallback(()=>id == null ? undefined : collection.get(id), [
        collection,
        id
    ]);
    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
